var exports = {
  "p": "x8b4e8595--c4bfa2--list",
  "z": "x8b4e8595--c4bfa2--bottom-margin",
};

module.exports = exports;
